import {MinorTasksHome} from './components/MinorManagement';
import { TasksHome } from './components/OperationalDeadlines';
// src/HomePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaFileAlt, FaAddressBook, FaCalendarAlt, FaFileExport, FaCog, FaTools } from 'react-icons/fa';
import './HomePage.css'; // Creeremo anche un file CSS per lo stile

const HomePage = () => {
  const menuItems = [
    { name: 'Pratiche', icon: <FaFileAlt size={80} />, path: '/schede' },
    { name: 'Contatti', icon: <FaAddressBook size={80} />, path: '/contatti' },
    { name: 'Agenda', icon: <FaCalendarAlt size={80} />, path: '/agenda' },
    { name: 'Esportazioni', icon: <FaFileExport size={80} />, path: '/esportazioni' },
    { name: 'Strumenti', icon: <FaTools size={80} />, path: '/strumenti' },
    { name: 'Impostazioni', icon: <FaCog size={80} />, path: '/impostazioni' }
  ];

  return (
    <div className="home-page">
      <h1>CISA</h1>
      <MinorTasksHome /><TasksHome />
      <div className="icon-grid">
        {menuItems.map((item) => (
          <Link key={item.name} to={item.path} className="menu-item">
            <div className="icon">{item.icon}</div>
            <div className="label">{item.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HomePage;

